export default "__VITE_ASSET__CJkJ$BKS__"